"use strict";

export default {
	DATA_TYPE_54ac0f62f556ea16b4a31fd3: "Temperature",
	DATA_TYPE_56ae4600a9052b2d26abb364: "Engine coolant temperature",
	DATA_TYPE_56ae460ea9052b2d26abb365: "Ambient temperature",
	DATA_TYPE_54ac0f62f556ea16b4a31fd4: "Position",
	DATA_TYPE_54ac0f62f556ea16b4a31fd5: "Max Speed",
	DATA_TYPE_5575710b084bdd983f1fc776: "Average Speed",
	DATA_TYPE_54ac0f62f556ea16b4a31fd6: "RPM",
	DATA_TYPE_54ac0f62f556ea16b4a31fd7: "Main Battery",
	DATA_TYPE_54ac0f62f556ea16b4a31fd8: "Backup Battery",
	DATA_TYPE_54ac0f62f556ea16b4a31fda: "Mobile Network Code",
	DATA_TYPE_54ac0f62f556ea16b4a31fdb: "GSM signal",
	DATA_TYPE_54ac0f62f556ea16b4a31fdc: "ODO",
	DATA_TYPE_54ac0f62f556ea16b4a31fde: "Total hours of operation",
	DATA_TYPE_54ac0f62f556ea16b4a31fdf: "Fuel Level",
	DATA_TYPE_54ac0f62f556ea16b4a31fe0: "Total use of fuel",
	DATA_TYPE_54ac0f63f556ea16b4a31fe1: "Number of Axles",
	DATA_TYPE_54ac0f63f556ea16b4a31fe2: "Engine Load",
	DATA_TYPE_54ac0f63f556ea16b4a31fe3: "Accelerator Pedal Position",
	DATA_TYPE_54ac0f63f556ea16b4a31fe4: "Brake Force",
	DATA_TYPE_54ac0f63f556ea16b4a31fe5: "Fuel Consumption",
	DATA_TYPE_54cd8595dd975aff54a3f1b9: "Ignition",

	MONTH_0: "January",
	MONTH_1: "February",
	MONTH_2: "March",
	MONTH_3: "April",
	MONTH_4: "May",
	MONTH_5: "June",
	MONTH_6: "July",
	MONTH_7: "August",
	MONTH_8: "September",
	MONTH_9: "October",
	MONTH_10: "November",
	MONTH_11: "December",

	DASHBOARD: "Dashboard",
	SEAGAL: "Seagal",
	NAME: "Name",
	PLATE_NUMBER: "Plate number",
	VIN: "Vehicle Identification Number",
	MAKE: "Make",
	YEAR_OF_PRODUCTION: "Year of production",
	WEIGHT: "Weight",
	HEIGHT: "Height",
	LENGTH: "Length",
	WIDTH: "Width",
	COLOR: "Color",
	AXLE_NUMBER: "Number of axles",
	VOLTAGE: "Voltage",
	TIME: "Time",
	VOLUME: "Volume",
	ADDRESS: "Address",
	DISTANCE_TRAVELLED: "Distance travelled",
	TRAVEL_TIME: "Travel time",
	TOTAL_VEHICLE_DISTANCE: "ODO",
	START_TOTAL_VEHICLE_DISTANCE: "Start ODO",
	END_TOTAL_VEHICLE_DISTANCE: "End ODO",
	AVERAGE_SPEED: "Average speed",
	MAXIMUM_SPEED: "Maximum speed",
	START_TIME: "Start time",
	END_TIME: "End time",
	START_ADDRESS: "Start address",
	END_ADDRESS: "End address",
	ALL: "All",

	GETADDRESS: "Get address",
	IGNITION_ON: "Ignition ON",
	IGNITION_OFF: "Ignition OFF",
	MOVING: "Moving",
	LOGOUT: "Logout",
	LOGIN: "Login",
	RETRY: "Retry",
	SAVE: "Save",
	_SEARCH: "search",
	_USERNAME: "username",
	_PASSWORD: "password",
	NOTHING_FOUND: "Nothing found",
	BAD_REQUEST_DATA: "Bad request data",
	WRONG_USER_OR_PASSWORD: "Username / Password is incorrect",
	SOMETHING_WRONG: "Something wrong",
	PROPERTIES_UPDATED: "Properties successfully updated",
	GETTING_APPLICATION_DATA: "Getting application data",
	GETTING_VEHICLES: "Getting vehicles",
	ERROR_VIA_GETTING_DATA: "Oops, error via getting data",
	SETTINGS: "Settings",
	PROPERTIES: "Properties",
	REPORTS: "Reports",
	ACTIVITY: "Activity",
	SHARE: "Share",
	USER: "User",
	PRIVILEGE: "Privilege",
	HEATMAP: "Heatmap",
	TIME_BASED: "Time based",
	ROUTE_BASED: "Route based",
	OPERATION_FAILED: "Operation failed",
	SUCCESFUL_OPERATION: "Succesful operation",
	INVALID_FORMAT: "Invalid format",
	FROM: "From",
	TO: "To",
	TOO_LONG_INTERVAL: "Too long interval",
	SUBMIT: "Submit",
	EXPORT: "Export",
	CANCEL: "Cancel",
	CREATE: "Create",
	NO_RESULTS_FOUND: "No results found",
	UNKNOWN: "Unknown",
	DEPARTURE: "Departure",
	ARRIVAL: "Arrival",
	EN_ROUTE: "En route",
	MAP: "Map",
	USERS: "Users",
	AUTOZOOM: "Autozoom",
	TRAFFIC: "Traffic",
	RADIAL: "Radial",
	POLYGONAL: "Polygonal",
	ROUTES: "Routes",
	STOPS: "Stops",
	SECTION: "Section",
	POI_CROSSINGS: "POI crossings",
	TIMELINE: "Timeline",
	STAYS: "Stays",
	SUMMARIES: "Summaries",
	SUMMARY: "Summary",
	SUMMARY_FOR: "Summary for",
	POIS: "POIs",
	
	//VehicleReports
	EXPORTASPDF: "Export as PDF",
	EXPORTASHTML: "Export as HTML",
	EXPORTASCSV: "Export as CSV",


	NUMBER_OF_STARTS: "Number of starts",
	NUMBER_OF_STOPS: "Number of stops",
	NUMBER_OF_ARRIVALS: "Number of enter",
	NUMBER_OF_DEPARTURES: "Number of exit",
	IGNITION_TIME: "Ignition time",
	NON_IGNITION_TIME: "Non-ignition time",
	NUMBER_OF_SECTIONS: "Number of sections",
	STAY_TIME: "Stay time",
	DISTANCE_TRAVELED_WITHIN_POI: "Distance traveled within POI",
	SPEED: "Speed",
	STILL_IN_POI: "Still in POI",
	ALREADY_IN_POI: "Already in POI",
	SUM: "Sum",
	MIN: "Min",
	MAX: "Max",
	AVG: "Avg",

	NOW: "Now",
	DONE: "Done",

	PRIVILEGE_ERROR_DASHBOARD: "You do not have dashboard access",

	CREATE_POI: "Create POI",
	CREATE_POI_DIALOG_TITLE: "Create new POI",
	SHAPE: "Shape",
	CIRCLE_SHAPE: "Circle shape",
	POLYGON_SHAPE: "Polygon shape",
	EDIT_SHAPE: "Edit shape",
	RESTORE_SHAPE: "Restore shape",
	DISCARD: "Discard",
	OK: "Ok",
	DELETE: "Delete",
	ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POI: "Are you sure you want to delete this POI",
	
	GETTING_COLLABORATORS: "Getting collaborators",
	ADD_COLLABORATOR: "Add collaborator",
	SHARE_POI: "Share POI",
	SHARE_WITH: "Share with",
	COLLABORATOR: "Collaborator",
	COLLABORATORS: "Collaborators",
	_GROUP: "group",

	CAN_VIEW: "Can view",
	CAN_SHARE: "Can share",
	CAN_EDIT: "Can edit",
	CAN_DELETE: "Can delete",

	YOU_CANNOT_REMOVE_COLLABORATOR: "You cannot remove collaborator",
	YOU_CANNOT_CHANGE_PRIVILEGE: "You cannot change privilege",
	DO_YOU_WANT_TO_SAVE_CHANGES: "Do you want to save changes?",
	YES: "Yes",
	NO: "No",

	_HOST_URL: "host url",
	SELECT_HOST: "Select host",
	CHECKING_INTERNET_CONNECTION: "Checking internet connection",

	CONSOLE: "Console",
	CONFIG: "Config",
	CARRIERS: "Carriers",
	GETTING_DEVICES: "Getting devices",
	PRIMARY: "PRIMARY",
	CLIENT_ACCESS: "CLIENT ACCESS",
	LOCAL: "LOCAL",
	REMOTE: "REMOTE",
	CONNECTING: "Connecting",
	SHOW_USER_INPUT: "Show user input",
	HIDE_USER_INPUT: "Hide user input",
	WORD_WRAP_ON: "Word wrap on",
	WORD_WRAP_OFF: "Word wrap off",
	SNAP_TO_END: "Snap to end",
	FIRMWARE_UPGRADE: "Firmware upgrade",
	FROM_FILE: "From file",
	BURN: "Burn",
	START: "Start",
	STOP: "Stop",
	CONTINUE: "Continue",
	CHECK: "Check",
	VERSION: "Version",
	SOURCE: "Source",
	BROWSE: "Browse",
	CURRENT_VERSION: "Current version",
	UPLOADED_VERSION: "Uploaded version",
	ERROR_INCOMPATIBLE_FILE: "ERROR: Incompatible file!",
	LOADING: "Loading",
	UPLOADING: "Uploading",
	LOADED: "Loaded",
	PARSING: "Parsing",
	INITIALIZATION_FAILED: "Initialization failed",
	STATE: "State",
	CHOOSE_CONFIG_TEMPLATE: "Choose config template!",
	CONFIG_UPDATE_FAILED: "Config update failed",
	ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_CONFIG: "Are you sure you want to remove this config?",
	RELOAD: "Reload",
	ENTITIES: "Entities",
	ENTITY_UPDATE_FAILED: "Entity update failed",
	ARE_YOU_SURE_YOU_WANT_TO_REMOVE_THIS_ENTITY: "Are you sure you want to remove this entity?",
	CHOOSE_ENTITY_TEMPLATE: "Choose entity template!",
	
	ADD_CARRIER: "Add carrier",
	CARRIER: "Carrier",
	PLACEMENT: "Placement",
	INTERVAL: "Interval",
	ARE_YOU_SURE_YOU_WANT_TO_UNBIND_CARRIER: "Are your sure you want to unbind this carrier",
	ADD: "Add",
	INPUTS: "Inputs",
	TYPE: "Type",
	CDID: "CDID",
	CREATED: "Created",
	HARDWARE_REVISION: "Hardware revision",
	FIRMWARE_VERSION: "Firmware version",
	PROTOCOL_TYPE: "Protocol type",

	INVALID_INTERVAL: "Invalid interval",
	CLICK_HERE_TO_FIX_IT: "Click here to fix it",
	PASSWORD: "Password",
	CONTACTS: "Contacts",
	NOTIFICATIONS: "Notifications",
	OLD_PASSWORD: "Old password",
	NEW_PASSWORD: "New password",
	CONFIRM_NEW_PASSWORD: "Confirm new password",
	CONFIRM_PASSWORD_ERROR_MESSAGE: "Error: Password mismatch!",
	EVERY_FIELD_IS_REQUIRED: "Every field is required",
	CHANGE_PASSWORD_SUCCESSFUL: "Password successfully changed",
	FNAME: "First Name",
	LNAME: "Last Name",
	EMAIL: "Email",
	PHONE: "Phone",
	WEB: "Web",
	TEXT_MESSAGE: "Text message",
	POI_CROSSING_NOTIFICATIONS: "POI crossing notifications",
	CRITICAL_VALUE_NOTIFICATIONS: "Critical value notifications",
	VEHICLES: "Vehicles",
	SEND_NOTIFICATIONS_VIA: "Send notifications via",
	SEND_NOTIFICATIONS_AT: "Send notifications at",
	SET_NOTIFICATION: "Set notification",
	ADD_NOTIFICATION_SETUP: "Add notification setup",
	DEPARTING: "Departing",
	ARRIVING: "Arriving",
	YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR: "Your modifications will take effect within one hour",
	INVALID_CONFIGURATION: "Invalid configuration",
	CONDITION: "Condition",
	SEND_NOTIFICATION_IF_THE_CONDITION_IS_FULFILLED_FOR: "Send notification if the condition is fulfilled for",
	_BETWEEN: "between",
	_NOT_BETWEEN: "not between",
	_AND: "and",
	
	_SECOND: "second",
	_SECONDS: "seconds",
	_MINUTE: "minute",
	_MINUTES: "minutes",
	_HOUR: "hour",
	_HOURS: "hours",

	
	_OR_SELECT_ONE_BY_ONE: "or select one by one",
	SELECT_POIS: "Select pois",
	CHANGE_PASSWORD: "Change password",
	SET_CONTACTS: "Set contacts"
};



// WEBPACK FOOTER //
// ./~/vwa/lang.js